import {AnimationBaseController, IAnimationControllerConfiguration, Inject} from '@denishussar/html5-game-engine';
import {Container, Point} from 'pixi.js';
import {AnimationContents} from '../../../AnimationContents';
import {ButtonController, IButtonControllerOptions} from '../../Common/ButtonController';
import {GameModel, GameStateEnum} from '../../Models/GameModel';
import {GameLogic} from '../../Logic/GameLogic';
import { IShopSuperPackControllerOptions, ShopSuperPackController } from './Shop/ShopSuperPackController';
import { IShopMegaPackControllerOptions, ShopMegaPackController } from './Shop/ShopMegaPackController';
import { IShopMoneyControllerOptions, ShopMoneyController } from './Shop/ShopMoneyController';

export interface IShopScreenControllerOptions {
}

export class ShopScreenController extends AnimationBaseController {
    $model: GameModel;
    _width: number;

    private _bgWidth: number = 0;
    private _bgHeight: number = 0;
    

    public constructor(
        @Inject private _options: IShopScreenControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('ShopScreenController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.SHOP_SCREEN_JSON,
            libraryName: 'shop_page',
            childControllers: {
                btn_exit: {
                    instanceName: 'btn_exit',
                    controller: ButtonController,
                    options: <IButtonControllerOptions> {
                        onClick: (status: boolean) => {
                            this._gameLogic.modalsManager.hide();
                        }
                    }
                },
                super_pack: {
                    instanceName: 'content.super_pack',
                    controller: ShopSuperPackController,
                    model: this.$model,
                    options: <IShopSuperPackControllerOptions> {
                        leaves: 5 * 60,
                        price: 3000
                    }
                },
                mega_pack: {
                    instanceName: 'content.mega_pack',
                    controller: ShopMegaPackController,
                    model: this.$model,
                    options: <IShopMegaPackControllerOptions> {
                        leaves: 1,
                        price: 2000,
                        boosterBrush: 1,
                        boosterHook: 1,
                        boosterLine: 1
                    }
                },
                money_pack_0: {
                    instanceName: 'content.money_pack_0',
                    controller: ShopMoneyController,
                    model: this.$model,
                    options: <IShopMoneyControllerOptions> {
                        coins: 1000,
                    }
                },
                money_pack_1: {
                    instanceName: 'content.money_pack_1',
                    controller: ShopMoneyController,
                    model: this.$model,
                    options: <IShopMoneyControllerOptions> {
                        coins: 2000,
                    }
                },
                money_pack_2: {
                    instanceName: 'content.money_pack_2',
                    controller: ShopMoneyController,
                    model: this.$model,
                    options: <IShopMoneyControllerOptions> {
                        coins: 3000,
                    }
                },
                btn_more: {
                    instanceName: 'content.more_pack.btn_next_active',
                    controller: ButtonController,
                    options: <IButtonControllerOptions> {
                        onClick: (status: boolean) => {
                            
                        }
                    }
                }
            },
        };
    }

    protected onInitialize() {
        this._width = 1920;

        // const bg = this.getDisplayObjectByQuery('bg')[0] as Container;
        // this._bgWidth = bg.width;
        // this._bgHeight = bg.height;

        console.log('SHOW ASD')
    }

    protected onResize(width: number, height: number, scale: number) {
        const contentScale = Math.min(width / scale / 1920, height / scale / 1440);
        // const bgScale = Math.max(width / scale / this._bgWidth, height / scale / this._bgHeight);

        
        this.setScaleByQuery('content', contentScale, contentScale);
        // this.setScaleByQuery('bg', bgScale, bgScale);

        const margin = 20;

        const topLeftPoint = this.display.toLocal(new Point(0, 0), this.renderer.stage);
        const bottomRightPoint = this.display.toLocal(new Point(width, height), this.renderer.stage);

        const btnExit = this.$childControllers.get('btn_exit').display;
        btnExit.x = bottomRightPoint.x - btnExit.width / 2 - margin;
        btnExit.y = topLeftPoint.y + btnExit.height / 2 + margin;

        /*const leaves = this.$childControllers.get('leaves').display;
        leaves.x = topLeftPoint.x + leaves.width / 2 + margin;
        leaves.y = topLeftPoint.y + leaves.height / 2 + margin;

        const coins = this.$childControllers.get('coins').display;
        coins.x = leaves.x + leaves.width;
        coins.y = topLeftPoint.y + coins.height / 2 + margin;*/
    }
}
